import { TransactionStatus } from '@40seas/entities/transactions';
import { EnumColor } from '@40seas/frontend/common/providers';

export const transactionStatusColorMapping = {
    [TransactionStatus.Done]: 'success',
    [TransactionStatus.Failed]: 'error',
    [TransactionStatus.InProgress]: 'info',
    [TransactionStatus.Pending]: 'default',
    [TransactionStatus.Initiated]: 'default',
    [TransactionStatus.Canceled]: 'error',
} as { [key in TransactionStatus]: EnumColor };
